export var config = {
  background: '#272822',
  foreground: '#f8f8f2',
  selection: '#4a4a76',
  selectionMatch: '#4a4a76',
  cursor: '#f8f8f0',
  dropdownBackground: '#414339',
  activeLine: '#3e3d3257',
  matchingBracket: '#3e3d32',
  keyword: '#F92672',
  storage: '#F92672',
  variable: '#FD971F',
  parameter: '#FD971F',
  function: '#66D9EF',
  string: '#E6DB74',
  constant: '#AE81FF',
  type: '#66D9EF',
  class: '#A6E22E',
  number: '#AE81FF',
  comment: '#88846f',
  heading: '#A6E22E',
  invalid: '#F44747',
  regexp: '#E6DB74',
  tag: '#F92672'
};